<ion-app>

  @if (!isFormRoute()) {
    <ion-header>
      <ion-toolbar style="height:57px" >
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
          <img height="27px" src="./assets/img/1risk-1097x400.png" />
        </ion-title>
        <ion-buttons slot="end">
          <ion-button color="primary" fill="solid" size="small" id="new-incident" style="margin-right: 20px"><ion-icon name="add-circle" slot="start"></ion-icon> Incident</ion-button>
          <app-user-menu></app-user-menu>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  }

  <ion-split-pane style="margin-top:57px" contentId="main-content">
    @if (!isFormRoute()) {
      <ion-menu contentId="main-content" type="overlay">
        <ion-content>
          <ion-menu-toggle auto-hide="false">
            <div style="margin-top:35px">
              @for (p of appPages; track p; let i = $index) {
                @if (user && (!((p.icon == 'settings' || p.icon == 'document-text' || p.icon == 'map') && user.userIsAdmin == false) || ((p.icon == 'document-text' || p.icon == 'map') && user.userIsManager == true) )) {
                  <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false"
                    routerLinkActive="selected">
                    <ion-button class="menu-button" fill="clear">
                      <ion-icon color="medium" slot="icon-only" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                    </ion-button>
                    <ion-label>{{ p.title }}</ion-label>
                  </ion-item>
                }
              }
            </div>
          </ion-menu-toggle>
          <ion-modal trigger="new-incident">
            <ng-template>
              <ion-content class="ion-padding" style="padding:30px">
                <ion-text>
                  <h1>New Incident</h1>
                </ion-text>
                <ion-text>
                  <p>Select an active incident type:</p>
                </ion-text>
                @for (incidentType of incidentTypes; track incidentType) {
                  @if (incidentType.active) {
                    <ion-item (click)="incidentTypeSelected(incidentType._id)" button lines="none">
                      <ion-avatar style="width: 60px"><ion-chip
                        [style.color]="incidentType.color" [style.background-color]="incidentType.color + '30'"><b>{{incidentType.key}}</b></ion-chip></ion-avatar>
                        <ion-label><b>{{incidentType.name}}</b>
                        <p>{{incidentType.description}}</p>
                      </ion-label>
                    </ion-item>
                  }
                }
                <ion-toolbar>
                  <ion-buttons slot="start">
                    <ion-button fill="solid" color="primary" (click)="closeIncidentModal()">Cancel</ion-button>
                  </ion-buttons>
                </ion-toolbar>
              </ion-content>
            </ng-template>
          </ion-modal>
          <!--ion-list id="labels-list">
          <ion-list-header>Labels</ion-list-header>
          <ion-item *ngFor="let label of labels" lines="none">
            <ion-icon slot="start" ios="bookmark-outline" md="bookmark-sharp"></ion-icon>
            <ion-label>{{ label }}</ion-label>
          </ion-item>
        </ion-list-->
      </ion-content>
    </ion-menu>
  }
  <div id="main-content">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-split-pane>
</ion-app>